import React, {Component} from 'react';
import Offers from '../Tab2/Offers';

export default class Tab1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOffers: false,
    };
  };

  render() {
    const styles = {
      containerCardFamily: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
      containerGroupCard: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
      },
      card: {
        margin: 10,
        width: '100%',
      },
      maps: {
        width: '56%',
        marginTop: 10,
      },
      altima: {
        width: '17%',
      },
      floattingActionButton: {
        position: 'fixed',
        bottom: 30,
        right: 30,
      },
      title: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: 10,
      },
      containerCard: {
        padding: 30,
        fontFamily: 'Poppins',
        fontWeight: 600,
      }
    };

    const {showOffers} = this.state;

    return (
      <div style={styles.containerCard}>

        <div style={styles.containerGroupCard}>

          <div style={styles.card} className="row">
            <div className="col s12">
              <div className="card white darken-1">
                <div style={{padding: 0}} className="card-content">
                  <div style={styles.title} className="header-title">
                    <i class="small material-icons">group</i>
                    &nbsp;
                    <span className="card-title customFontHeader" className="header-label">Famille</span>
                  </div>
                  <div style={styles.containerCard}>
                    <div style={styles.card}>
                      <p><strong>Civilité :</strong> Monsieur</p>
                      <p><strong>Nom :</strong> Doe</p>
                      <p><strong>Prénom :</strong> John</p>
                      <p><strong>Naissance :</strong> 01/01/1964 à Lille (59000)</p>
                    </div>
                    <div style={styles.card}>
                      <p><strong>Civilité :</strong> Madame</p>
                      <p><strong>Nom :</strong> Doe</p>
                      <p><strong>Prénom :</strong> Clair</p>
                      <p><strong>Naissance :</strong> 01/04/1970 à Rennes (35000)</p>
                    </div>
                    <div style={styles.card}>
                      <p><strong>Civilité :</strong> Madame</p>
                      <p><strong>Nom :</strong> Doe</p>
                      <p><strong>Prénom :</strong> Jude</p>
                      <p><strong>Naissance :</strong> 03/05/2012 à Paris (75001)</p>
                    </div>
                    <p style={{paddingBottom: 10}}>&nbsp;</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div style={styles.card} className="row">
            <div className="col s12">
              <div className="card white darken-1">
                <div style={{padding: 0}} className="card-content">
                  <div style={styles.title} className="header-title">
                    <i class="small material-icons">directions_car</i>
                    &nbsp;
                    <span className="card-title customFontHeader" className="header-label">Véhicule</span>
                  </div>
                  <div style={styles.containerCard}>
                    <div style={styles.card}/>
                    <p><strong>Marque :</strong> PEUGEOT</p>
                    <p><strong>Modèle :</strong> 308</p>
                    <p><strong>Finition:</strong> GT Line</p>
                    <p><strong>Energie :</strong> Diesel</p>
                    <p><strong>Immatriculation :</strong> EF-873-GN</p>
                    <p><strong>Puissance fiscale:</strong> 7CV</p>
                    <p><strong>Puissance din:</strong> 130CH</p>
                    <p><strong>Genre :</strong> VEH.DE TOURISME</p>
                    <p><strong>1ère mise en circulation :</strong> 01/01/2017</p>
                    <p style={{marginBottom: 20}}><strong>Commune de stationnement :</strong> LA ROCHELLE (17000)</p>
                    <img src="/images/peugeot.png" alt="pigeot" style={{height: '78px'}}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div style={styles.containerGroupCard}>
          <div style={styles.card} className="row">
            <div className="col s12">
              <div className="card white darken-1">
                <div style={{padding: 0}} className="card-content">
                  <div style={styles.title} className="header-title">
                    <i class="small material-icons">assignment</i>
                    &nbsp;
                    <span className="card-title customFontHeader" className="header-label">Assurance</span>
                  </div>
                  <div style={styles.containerCard}>
                    <div style={styles.card}/>
                    <p><strong>Assureur :</strong> ALTIMA ASSURANCES</p>
                    <p><strong>Offre :</strong> Assurance à la minute</p>
                    <p><strong>Garantie :</strong> Tiers plus</p>
                    <p><strong>Date de souscription :</strong> 23/06/2010</p>
                    <br/>
                    <br/>
                    <div style={styles.containerMaps}>
                      <img style={styles.altima} alt="maps" src="/images/altima-logo.png"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div style={styles.card} className="row">
            <div className="col s12">
              <div className="card white darken-1">
                <div style={{padding: 0}} className="card-content">
                  <div style={styles.title} className="header-title">
                    <i class="small material-icons">location_on</i>
                    &nbsp;
                    <span className="card-title customFontHeader" className="header-label">Localisation</span>
                  </div>
                  <div style={styles.containerCard}>
                    <div style={styles.card}/>
                    <p>66 Avenue des Gobelins</p>
                    <p>75013 Paris</p>
                    <div>
                      <img style={styles.maps} alt="maps" src="/images/maps.png"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}